import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import NiboWhatsAppConnection from '../../models/nibo-whatsapp-connection';

@Component({
  standalone: false,
  selector: 'app-connection-confirm-delete',
  templateUrl: './connection-confirm-delete.component.html',
  styleUrls: ['./connection-confirm-delete.component.css']
})
export class ConnectionConfirmDeleteComponent implements OnInit {

  public updateData: { connection: NiboWhatsAppConnection };

  constructor(@Inject(MAT_DIALOG_DATA) public data: { connection: NiboWhatsAppConnection },
    public dialogRef: MatDialogRef<ConnectionConfirmDeleteComponent>) {
    this.updateData = data;
  }

  ngOnInit(): void {
  }

  public confirm() {
    this.dialogRef.close(true);
  }

  public cancel() {
    this.dialogRef.close(false);
  }

}
